import { SanitizerService } from '@anecdotes/utils';
import { ChangeDetectionStrategy, Component, ElementRef, HostBinding, Input } from '@angular/core';

@Component({
  selector: 'app-formatted-text',
  template: '',
  styleUrls: ['./formatted-text.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormattedTextComponent {
  // Don't remove 'ql-editor' class, it's important for correct displaying of formatted text
  @HostBinding('class')
  private readonly classes = 'ql-editor';

  @Input()
  set text(value: string) {
    const sanitizedText = this.sanitizer.sanitizeRichText(value);
    this.elementRef.nativeElement.innerHTML = sanitizedText;
  }

  constructor(private elementRef: ElementRef<HTMLElement>, private sanitizer: SanitizerService) {}
}
